__turbopack_context__.v({
  "container": "_app-module-scss-module__sW0uBq__container",
});
